(function (global) {
  function pickFields(source, fields) {
    const out = {};
    fields.forEach(function (field) {
      if (source[field] !== undefined) {
        out[field] = source[field];
      }
    });
    return out;
  }

  function numberOrDefault(value, fallback) {
    if (global.NumberUtils && typeof global.NumberUtils.toNumber === 'function') {
      return global.NumberUtils.toNumber(value, fallback);
    }

    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  var contracts = {
    fire: {
      version: 3,
      fields: ['currentAge', 'retirementAge', 'growthRate', 'contributionFrequency', 'initial401k', 'initialRoth', 'initialTaxable', 'contribution401k', 'contributionRoth', 'contributionTaxable', 'contributionIncrease', 'annualSpend'],
      normalize: function (state) {
        return {
          currentAge: numberOrDefault(state.currentAge, 30),
          retirementAge: numberOrDefault(state.retirementAge, 50),
          growthRate: numberOrDefault(state.growthRate, 7),
          contributionFrequency: state.contributionFrequency || 'monthly',
          initial401k: numberOrDefault(state.initial401k, 50000),
          initialRoth: numberOrDefault(state.initialRoth, 25000),
          initialTaxable: numberOrDefault(state.initialTaxable, 15000),
          contribution401k: numberOrDefault(state.contribution401k, 1000),
          contributionRoth: numberOrDefault(state.contributionRoth, 500),
          contributionTaxable: numberOrDefault(state.contributionTaxable, 500),
          contributionIncrease: numberOrDefault(state.contributionIncrease, 0),
          annualSpend: numberOrDefault(state.annualSpend, 80000)
        };
      },
      pick: function (state) {
        return pickFields(state, this.fields);
      }
    },
    advancedFire: {
      version: 3,
      fields: ['currentAge', 'retirementAge', 'lifeExpectancy', 'preRetirementGrowth', 'postRetirementGrowth', 'taxRate', 'withdrawalRate', 'inflationRate', 'contributionFrequency', 'initial401k', 'initialRoth', 'initialTaxable', 'contribution401k', 'contributionRoth', 'contributionTaxable', 'contributionIncrease', 'penaltyFreeAge', 'bracketCapGross', 'bracketCapGrowth'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    },
    coastFire: {
      version: 2,
      fields: ['currentAge', 'retirementAge', 'currentSavings', 'targetMethod', 'annualExpenses', 'withdrawalRate', 'targetFIRENumber', 'expectedReturn', 'inflationRate'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    },
    compoundInterest: {
      version: 2,
      fields: ['principal', 'monthlyContribution', 'interestRate', 'years', 'compoundFrequency'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    },
    retirementGoal: {
      version: 2,
      fields: ['retirementGoal', 'currentSavings', 'currentAge', 'retirementAge', 'expectedReturn'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    },
    budgetPlanner: {
      version: 2,
      fields: ['incomes', 'expenses'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    },
    debtPayoff: {
      version: 2,
      fields: ['debts', 'extraPayment', 'selectedStrategy'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    },
    emergencyFund: {
      version: 2,
      fields: ['expenses', 'currentSavings', 'monthlyContribution', 'employment', 'incomeSources', 'dependents', 'jobMarket'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) {
        var normalized = pickFields(state, this.fields);
        if (!normalized.employment && state.jobStability) {
          normalized.employment = state.jobStability;
        }
        if (!normalized.incomeSources && state.incomeStability) {
          normalized.incomeSources = state.incomeStability;
        }
        if (!normalized.jobMarket && state.healthRisk) {
          normalized.jobMarket = state.healthRisk;
        }
        return normalized;
      }
    },
    mortgage: {
      version: 2,
      fields: ['homePrice', 'downPayment', 'interestRate', 'loanTermYears', 'propertyTax', 'homeInsurance', 'pmi', 'hoa', 'extraPayment'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    },
    paycheck: {
      version: 2,
      fields: ['salary', 'payFrequency', 'filingStatus', 'state', 'contribution401kPercent', 'healthInsurance', 'hsa', 'otherPreTax'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    },
    rentVsBuy: {
      version: 2,
      fields: ['monthlyRent', 'rentIncrease', 'rentersInsurance', 'homePrice', 'downPayment', 'interestRate', 'loanTermYears', 'propertyTax', 'homeInsurance', 'maintenancePercent', 'homeAppreciation', 'investmentReturn', 'closingCostsBuy', 'sellingCostsPercent', 'timeHorizon'],
      pick: function (state) { return pickFields(state, this.fields); },
      normalize: function (state) { return pickFields(state, this.fields); }
    }
  };

  function get(contractId) {
    return contracts[contractId] || null;
  }

  function encode(contractId, state) {
    var contract = get(contractId);
    if (!contract) return state;

    var data = contract.pick ? contract.pick(state) : state;
    return {
      v: contract.version || 1,
      c: contractId,
      d: data
    };
  }

  function decode(contractId, payload) {
    var contract = get(contractId);
    if (!contract) return payload;

    if (payload && payload.c && payload.d !== undefined) {
      if (payload.c === contractId) {
        return contract.normalize ? contract.normalize(payload.d) : payload.d;
      }
      return null;
    }

    // Legacy payload (pre-contract).
    return contract.normalize ? contract.normalize(payload || {}) : (payload || {});
  }

  global.UrlStateContracts = {
    get: get,
    encode: encode,
    decode: decode
  };
})(window);
